import { FEATURE_FLAG } from '~/constants';

import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  permissions: ['dln_in.'],
  featureFlag: FEATURE_FLAG.CREATE_DELIVERY_NOTE,
};
